module.exports = __webpack_public_path__ + "img/salada.349504e0.svg";